// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"283":"661bfa9c","355":"1add9b81","468":"5a483011","510":"54989c97","538":"f0188dd9","879":"c66a69e6"}[chunkId] + ".chunk.css";
};